import React from 'react';
import DatePicker from '@nib-components/date-picker';
import FormControl from '@nib-components/form-control';
import { defaultFieldPropTypes } from '../../types';
import { errorMessage, isValid, isTouched } from '../../util/validationHelpers';
import { combineHandlerWithFormik } from '../../util/eventHelpers';
import { FUNNELS } from '../../util/constants';
const BaseDate = _ref => {
  let {
    id,
    label,
    funnel = FUNNELS.ARHI,
    name,
    help,
    input,
    field,
    width = 15,
    disabled,
    form,
    onBlur,
    onChange,
    optional = false,
    ...otherProps
  } = _ref;
  // name is moved to field.name for formik, input.name for redux-form
  const isFormik = Boolean(field);
  const isReduxForm = Boolean(input);
  const formikOnChange = e => form === null || form === void 0 ? void 0 : form.setFieldValue(id, e);
  const formikOnBlur = () => form === null || form === void 0 ? void 0 : form.setFieldTouched(id, true);
  let inputName = name;
  let handleBlur = onBlur;
  let handleChange = onChange;
  if (isFormik) {
    handleBlur = combineHandlerWithFormik(formikOnBlur, onBlur);
    handleChange = combineHandlerWithFormik(formikOnChange, onChange);
    inputName = field === null || field === void 0 ? void 0 : field.name;
  } else if (isReduxForm) {
    // Redux-Form _helpfully_ sets the value of the field onBlur (even if a user is just tabbing through the form and not actively selecting an option)
    // todo: 99% sure the old code was wrong eg setting the handler to a result of a redux handler eg 'handleBlur = input.onBlur(undefined, true)'
    // This replacement code is whats been done in all other base components
    handleBlur = () => (input === null || input === void 0 ? void 0 : input.onBlur) ? input.onBlur(undefined, true) : (e, value) => {};
    handleChange = input === null || input === void 0 ? void 0 : input.onChange;
    inputName = input === null || input === void 0 ? void 0 : input.name;
  }
  const validState = isValid({
    ...otherProps,
    form,
    id
  });
  const validatedState = isTouched({
    ...otherProps,
    form,
    id
  });
  const errorState = errorMessage({
    ...otherProps,
    form,
    id
  });
  const inputFieldValue = isFormik ? field === null || field === void 0 ? void 0 : field.value : input === null || input === void 0 ? void 0 : input.value;
  return React.createElement(FormControl, {
    name: inputName,
    id: id,
    label: label || '',
    help: help,
    valid: validState,
    validated: validatedState,
    error: errorState,
    width: width,
    optional: optional,
    funnel: funnel,
    disabled: disabled
  }, React.createElement(DatePicker, {
    ...field,
    ...otherProps,
    width: width,
    autoComplete: "off",
    onBlur: handleBlur,
    onChange: handleChange,
    selected: inputFieldValue,
    value: inputFieldValue,
    optional: optional,
    funnel: funnel
  }));
};
BaseDate.defaultProps = {
  ...defaultFieldPropTypes,
  width: 15
};
export default BaseDate;